import React, { useState } from "react";
import { Form, Button, Card, Container, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import Swal from "sweetalert2";
import axios from "axios";

const ForgotPassword = () => {
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_APP_URL}/forgot-password/request`,
        { phone_number: phone },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Platform": process.env.REACT_APP_X_PLATFORM,
            "API-Key": process.env.REACT_APP_API_KEY,
            "X-API-Version": process.env.REACT_APP_X_API_VERSION,
          },
        }
      );

      Swal.fire({
        icon: "success",
        title: "OTP Dikirim",
        text: res.data.message,
      }).then(() => {
        navigate("/verify-reset-otp", { state: { phone } });
      });
    } catch (err) {
      const msg = err.response?.data?.message || "Gagal mengirim OTP.";
      Swal.fire({ icon: "error", title: "Gagal", text: msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <Card
        className="p-4 shadow-lg"
        style={{ width: "100%", maxWidth: "400px" }}
      >
        <h4 className="text-center mb-3">Lupa Password</h4>
        <p className="text-center text-muted">
          Masukkan nomor WhatsApp yang terdaftar untuk menerima kode reset.
        </p>

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Nomor WhatsApp</Form.Label>
            <div className="d-flex align-items-center border rounded px-2">
              <FaWhatsapp style={{ color: "#25D366", fontSize: "1.2rem" }} />
              <Form.Control
                type="text"
                className="border-0 ms-2"
                placeholder="081234567890"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
            </div>
          </Form.Group>

          <Button
            variant="success"
            type="submit"
            className="w-100"
            disabled={loading}
          >
            {loading ? <Spinner animation="border" size="sm" /> : "Kirim OTP"}
          </Button>

          <Button
            variant="link"
            className="w-100 mt-2"
            onClick={() => navigate("/login")}
          >
            Kembali ke Login
          </Button>
        </Form>
      </Card>
    </Container>
  );
};

export default ForgotPassword;
